import { Tool } from "./interfaces";

export const frameworks = [
  {
    type: "technology",
    name: "NodeJs",
    level: "Experienced",
    image: "Node.js_logo.svg",
    tags: ["Web", "Apps", "Front", "Back", "JS", "TS"],
    experience: "+5 year",
    description: "",
  },
  {
    type: "framework",
    name: "Vue JS",
    level: "Experienced",
    image: "vue-js.svg",
    tags: ["Web", "Front", "JS", "TS"],
    experience: "+2 year",
    description: "",
  },
  {
    type: "framework",
    name: "Angular",
    level: "Experienced",
    image: "angular.svg",
    tags: ["Web", "Front", "TS", "Google"],
    experience: "+3 years",
    description: "",
  },
  {
    type: "framework",
    name: "React Js",
    level: "Intermediate",
    image: "react.svg",
    tags: ["Web", "Front", "JS", "TS", "FB"],
    experience: "1 year",
    description: "",
  },
  {
    type: "framework",
    name: "NestJs",
    level: "Experienced",
    image: "nestjs-logo.svg",
    tags: ["Rest API", "GraphQL API", "Back", "Express", "Fastify"],
    experience: "+2 year",
    description: "",
  },
  // {
  //   type: "framework",
  //   name: "Nativescript",
  //   level: "Intermediate",
  //   image: "nativescript.png",
  //   tags: ["Mobile", "Front"],
  //   experience: "1 year",
  //   description: "",
  // },
  {
    type: "framework",
    name: "Express",
    level: "Experienced",
    image: "express.svg",
    tags: ["Web", "Backend", "JS", "TS", "API"],
    experience: "+5 years",
    description: "",
  },
  {
    type: "framework",
    name: "Flutter",
    level: "Intermediate",
    image: "flutter_logo.svg",
    tags: ["Mobile", "Front"],
    experience: "-1 year",
    description: "",
  },
  {
    type: "framework",
    name: "Flask",
    level: "Intermediate",
    image: "flask.svg",
    tags: ["Web", "Backend", "Python"],
    experience: "-1 year",
    description: "",
  },
  {
    type: "framework",
    name: "Django",
    level: "Intermediate",
    image: "django.svg",
    tags: ["Web", "Backend", "Python"],
    experience: "1 year",
    description: "",
  },
] as Array<Tool>;
